$(document).ready(function(){
  $('.u_aus_show').attr('style','display:inline-block !important')
     $('.u_all_text').attr('style','display:none  !important')
        $.getJSON("https://funsquare-geo.andrewjdouglas7.workers.dev", function (data) {
          var my_country = data.country;
          my_country = my_country.toLowerCase();
          countryCode = my_country;
             console.log('data ',data);
          console.log('my_country ',my_country);
          if(my_country == 'au'){
              $('.u_aus_show').attr('style','display:inline-block !important')
              $('.u_all_text').attr('style','display:none !important')
                 $('.u_mal_text').attr('style','display:none !important')
             $('.u_singa_text').attr('style','display:none !important')
                     $('.u_nz_text').attr('style','display:none !important')
              $('.u_rest_text').attr('style','display:none !important')
            console.log('Your country is australia');
          }
                else if(my_country == 'my'){
              $('.u_mal_text').attr('style','display:inline-block !important')
                     $('.u_singa_text').attr('style','display:none !important')
                     $('.u_nz_text').attr('style','display:none !important')
              $('.u_rest_text').attr('style','display:none !important')
                    $('.u_aus_show').attr('style','display:none !important')
            console.log('Your country is malaysia');
          }
                   else if(my_country == 'sg'){
              $('.u_mal_text').attr('style','display:none !important')
                     $('.u_singa_text').attr('style','display:inline-block !important')
                     $('.u_nz_text').attr('style','display:none !important')
              $('.u_rest_text').attr('style','display:none !important')
                       $('.u_aus_show').attr('style','display:none !important')
            console.log('Your country is singapore');
          }
                                        else if(my_country == 'nz'){
              $('.u_mal_text').attr('style','display:none !important')
                     $('.u_singa_text').attr('style','display:none !important')
                     $('.u_nz_text').attr('style','display:inline-block !important')
              $('.u_rest_text').attr('style','display:none !important')
                                            $('.u_aus_show').attr('style','display:none !important')
            console.log('Your country is New Zealand');
          }
           else{
          console.log("user is from outside australia")
              $('.u_all_text').attr('style','display:inline-block  !important')
                    $('.u_rest_text').attr('style','display:inline-block !important')
              $('.u_mal_text').attr('style','display:none !important')
                     $('.u_singa_text').attr('style','display:none !important')
                     $('.u_nz_text').attr('style','display:none !important')
               $('.u_aus_show').attr('style','display:none !important')
          }
        });
  $('.product__info-container').on('change','input[type=radio]',function(){
    console.log('deqwd')
    setTimeout(function(){
     $('.u_aus_show').attr('style','display:inline-block !important')
     $('.u_all_text').attr('style','display:none  !important')
        $.getJSON("https://funsquare-geo.andrewjdouglas7.workers.dev", function (data) {
          var my_country = data.country;
          my_country = my_country.toLowerCase();
          countryCode = my_country;
             console.log('data ',data);
          console.log('my_country ',my_country);
          if(my_country == 'au'){
              $('.u_aus_show').attr('style','display:inline-block !important')
              $('.u_all_text').attr('style','display:none !important')
                 $('.u_mal_text').attr('style','display:none !important')
             $('.u_singa_text').attr('style','display:none !important')
                     $('.u_nz_text').attr('style','display:none !important')
              $('.u_rest_text').attr('style','display:none !important')
            console.log('Your country is australia');
          }
                else if(my_country == 'my'){
              $('.u_mal_text').attr('style','display:inline-block !important')
                     $('.u_singa_text').attr('style','display:none !important')
                     $('.u_nz_text').attr('style','display:none !important')
              $('.u_rest_text').attr('style','display:none !important')
                    $('.u_aus_show').attr('style','display:none !important')
            console.log('Your country is malaysia');
          }
                   else if(my_country == 'sg'){
              $('.u_mal_text').attr('style','display:none !important')
                     $('.u_singa_text').attr('style','display:inline-block !important')
                     $('.u_nz_text').attr('style','display:none !important')
              $('.u_rest_text').attr('style','display:none !important')
                       $('.u_aus_show').attr('style','display:none !important')
            console.log('Your country is singapore');
          }
                                        else if(my_country == 'nz'){
              $('.u_mal_text').attr('style','display:none !important')
                     $('.u_singa_text').attr('style','display:none !important')
                     $('.u_nz_text').attr('style','display:inline-block !important')
              $('.u_rest_text').attr('style','display:none !important')
                                            $('.u_aus_show').attr('style','display:none !important')
            console.log('Your country is New Zealand');
          }
           else{
          console.log("user is from outside australia")
              $('.u_all_text').attr('style','display:inline-block  !important')
                    $('.u_rest_text').attr('style','display:inline-block !important')
              $('.u_mal_text').attr('style','display:none !important')
                     $('.u_singa_text').attr('style','display:none !important')
                     $('.u_nz_text').attr('style','display:none !important')
               $('.u_aus_show').attr('style','display:none !important')
          }
        });
          },1000)
  })
    });